import * as types from "../actions/actionTypes";

const initialState = {
    is_fetched: false,
    loading: true,
    data: [],
    storeStatus: false,
};

const DefaultConstructionPhase = (state = initialState, action) => {
    switch (action.type) {
        case types.DEFAULT_CONSTRUCTION_PHASE_LIST_REQUEST:
            return { ...state, loading: true };
        case types.DEFAULT_CONSTRUCTION_PHASE_LIST_SUCCESS:
            return { ...state, data: action.payLoad, loading: false, is_fetched: true };
        case types.DEFAULT_CONSTRUCTION_PHASE_LIST_FAILURE:
            return { ...state, loading: false };

        case types.DEFAULT_CONSTRUCTION_PHASE_STORE_REQUEST:
            return {...state,loading: true, storeStatus: false};
        case types.DEFAULT_CONSTRUCTION_PHASE_STORE_SUCCESS:            
            return {...state, loading: false, storeStatus: true};
        case types.DEFAULT_CONSTRUCTION_PHASE_STORE_FAILURE:            
            return {...state,loading: false, storeStatus: false};        

        default:
            return state;
    }
};

export default DefaultConstructionPhase;
